// Angular
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

// c3
import * as c3 from "c3";
@Component({
    selector: 'app-c3-threshold-diagram',
    templateUrl: "./c3-threshold-diagram.component.html",
    styleUrls: ["./c3-threshold-diagram.component.scss"],
    standalone: false
})
export class C3ThresholdDiagramComponent implements OnChanges {
  @Input() zoneData: any;
  @Input() from: string = 'main';
  chart: any = null;
  height = 200;
  constructor(private elRef: ElementRef) { }

  // detect changes to draw bar diagram
  ngOnChanges(changes: SimpleChanges): void {
    if (this.zoneData) {
      setTimeout(() => {
        this.generateChart();
      }, 0);
    }
  }

  // categorising data for plot the chart
  classifyThresholdValues(type: string, criticality: string) {
    // null values are coming from API which is considered as a good value (>=1.67)
    // setting those value as 2 to plot the graph
    this.zoneData?.forEach((znDtaEle: any) => {
      if (znDtaEle[type] === null) {
        znDtaEle[type] = 2;
      }
    });
    let chartList: any;
    switch (criticality) {
      case "A":
        chartList = this.zoneData?.filter((znDtaEle: any) => {
          return znDtaEle[type] < 0.67;
        });
        break;
      case "B":
        chartList = this.zoneData?.filter((znDtaEle: any) => {
          return znDtaEle[type] >= 0.67 && znDtaEle[type] < 1;
        });
        break;
      case "C":
        chartList = this.zoneData?.filter((znDtaEle: any) => {
          return znDtaEle[type] >= 1 && znDtaEle[type] < 1.33;
        });
        break;
      case "D":
        chartList = this.zoneData?.filter((znDtaEle: any) => {
          return znDtaEle[type] >= 1.33 && znDtaEle[type] < 1.67;
        });
        break;
      case "E":
        chartList = this.zoneData?.filter((znDtaEle: any) => {
          return znDtaEle[type] >= 1.67;
        });
        break;
    }
    return chartList;
  }

  // draw chart using c3 library
  generateChart() {
    let columns: Array<any> = [
      [
        "cp",
        this.classifyThresholdValues("cp", "A").length,
        this.classifyThresholdValues("cp", "B").length,
        this.classifyThresholdValues("cp", "C").length,
        this.classifyThresholdValues("cp", "D").length,
        this.classifyThresholdValues("cp", "E").length,
      ],
      [
        "cpk",
        this.classifyThresholdValues("cpk", "A").length,
        this.classifyThresholdValues("cpk", "B").length,
        this.classifyThresholdValues("cpk", "C").length,
        this.classifyThresholdValues("cpk", "D").length,
        this.classifyThresholdValues("cpk", "E").length,
      ],
      [
        "pp",
        this.classifyThresholdValues("pp", "A").length,
        this.classifyThresholdValues("pp", "B").length,
        this.classifyThresholdValues("pp", "C").length,
        this.classifyThresholdValues("pp", "D").length,
        this.classifyThresholdValues("pp", "E").length,
      ],
      [
        "ppk",
        this.classifyThresholdValues("ppk", "A").length,
        this.classifyThresholdValues("ppk", "B").length,
        this.classifyThresholdValues("ppk", "C").length,
        this.classifyThresholdValues("ppk", "D").length,
        this.classifyThresholdValues("ppk", "E").length,
      ],
    ];
    if (this.from === 'quality') {
      columns.splice(0, 2);
    }
    this.chart = c3.generate({
      bindto: this.elRef?.nativeElement.children[0],
      size: {
        height: this.height,
      },
      data: {
        columns,
        type: "bar",
        colors: {
          cp: "#4472C5",
          cpk: "#ED7E30",
          pp: "#A5A5A5",
          ppk: "#FFC100",
        },
      },
      bar: {
        width: { ratio: 0.75 },
      },
      axis: {
        x: {
          type: "category",
          categories: [
            "< 0.67",
            "0.67 - 1",
            "1 - 1.33",
            "1.33 - 1.67",
            "> 1.67",
          ],
        },
      },
      legend: {
        show: true,
      },
      tooltip: {
        format: {
          title: (d) => "Criticality",
        },
      },
    });
  }
}
